import React from 'react';
import WorkInProgressLogo from '../components/common/WorkInProgressLogo';

export function SessionsPage() {
	return (
		<div className="h-full w-full min-w-0 overflow-x-hidden">
			<WorkInProgressLogo />
		</div>
	);
}
